module.exports = __webpack_public_path__ + "img/6407d32f98ca0fe3312db422_awareness_02-01-p-1080.4423e980.png";